import { Button, CircularProgress, Modal } from "@mui/joy";
import { BASE_URL, WHITE } from "../../../appConstants";
import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import appError from "../../../appError";
import axios from "axios";
import CrossIcon from "../../../svg/Ads_Dashboard_Developement2/CrossIcon/elements.svg";

type AccessBrandModalProps = {
  accessType: string;
  userId: string;
  selectedBrand: string;
  setSelectedBrand: Dispatch<SetStateAction<string>>;
  setAccessToggle: Dispatch<SetStateAction<boolean>>;
  setAccessPlatformToggle: Dispatch<SetStateAction<boolean>>;
};
type Brand = {
  brand_id: string;
  brand_name: string;
};
const AccessBrandModal: React.FC<AccessBrandModalProps> = ({
  accessType,
  userId,
  selectedBrand,
  setSelectedBrand,
  setAccessToggle,
  setAccessPlatformToggle
}) => {
  const [brands, setBrands] = useState<Brand[]>([]);
  const [brandsFetchingDataSate, setBrandsFetchingDataState] =
    useState<string>("");

  const fetchBrands = async () => {
    if (!userId) return;
    const token = localStorage.getItem("token");
    try {
      setBrandsFetchingDataState("LOADING");
      const api = `${BASE_URL}user/getBrandByUser?user_id=${userId}`;
      const headers = { Authorization: `Bearer ${token}` };
      const result = await axios.get(api, { headers });
      const { brand_platform_mapping } = result?.data?.data;
      if (brand_platform_mapping?.length > 0) {
        setBrands(brand_platform_mapping);
        setBrandsFetchingDataState("SUCCESS");
      } else {
        setBrandsFetchingDataState("EMPTY");
      }
    } catch (error) {
      appError(error);
    }
  };

  useEffect(() => {
    fetchBrands();
  }, []);

  const brandChangeHandler = (ag_brandId: string) => {
    setSelectedBrand(ag_brandId);
  };

  const onProceedChangeHandler = () => {
    setAccessPlatformToggle(true);
    setAccessToggle(false);
  };

  return (
    <Modal
      open={true}
      sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
      className="h-full"
    >
      <div
        style={{ width: 700, backgroundColor: `${WHITE.W_100}` }}
        className="h-[400px] relative flex flex-col items-center rounded-[18px] px-10 py-10 gap-10"
      >
        {brandsFetchingDataSate === "LOADING" ? (
          <div className="h-full w-full flex justify-center items-center">
            <CircularProgress />
          </div>
        ) : brandsFetchingDataSate === "SUCCESS" ? (
          <div className="h-full w-full flex flex-col justify-between gap-10">
            <div className="flex justify-between gap-1 w-full">
              <div className="flex flex-col w-[60%]">
                <div
                  className="self-stretch"
                  style={{
                    color: `#1C1C1E`,
                    fontSize: 20,
                    fontStyle: "normal",
                    fontWeight: 700,
                    lineHeight: "26px",
                  }}
                >
                  Select Brand
                </div>
                <div
                  className="self-stetch"
                  style={{
                    color: `#97979A`,
                    fontSize: 14,
                    fontStyle: "normal",
                    fontWeight: 500,
                    lineHeight: "22px",
                  }}
                >
                  Select Brand for which you want to take Access
                </div>
              </div>
            </div>

            <div className="grid grid-cols-4 gap-x-10 gap-y-4 w-full">
              {brands?.map((brand) => {
                return (
                  <label
                    className="flex items-center gap-2"
                    key={brand?.brand_id}
                  >
                    <input
                      type="radio"
                      name="options"
                      value="keywordmapping"
                      checked={selectedBrand === brand?.brand_id}
                      style={{
                        width: 16,
                        height: 16,
                        accentColor: "black",
                        cursor: "pointer",
                      }}
                      onChange={() => brandChangeHandler(brand?.brand_id)}
                    />
                    {brand?.brand_name}
                  </label>
                );
              })}
            </div>

            <div className="flex items-start justify-center gap-[30px] self-stretch">
              <Button
                color="neutral"
                sx={{
                  height: "40px",
                  width: "50%",
                  backgroundColor: "#FFF",
                  ":hover": {
                    backgroundColor: "#FFF",
                  },
                  color: "#1C1C1E",
                  borderRadius: "8px",
                  border: "1px solid #F2F2F5",
                  padding: "0px 8px",
                  fontSize: "14px",
                  fontWeight: 700,
                  lineHeight: "18px",
                }}
                onClick={() => {
                  setSelectedBrand('');
                  setAccessToggle(false);
                }}
              >
                Cancel
              </Button>
              <Button
                onClick={() => onProceedChangeHandler()}
                sx={{
                  height: "40px",
                  width: "50%",
                  backgroundColor: "#1565C0",
                  color: "#FFF",
                  borderRadius: "8px",
                  padding: "0px 8px",
                  fontSize: "14px",
                  fontWeight: 700,
                  lineHeight: "18px",
                }}
                disabled={selectedBrand === ""}
              >
                Next
              </Button>
            </div>
          </div>
        ) : (
          <div className="h-full w-full flex justify-center items-center">
            <div
              style={{
                color: `#1C1C1E`,
                fontSize: 20,
                fontStyle: "normal",
                fontWeight: 700,
                lineHeight: "26px",
              }}
            >
              No Brands Assigned
            </div>
          </div>
        )}

        {brandsFetchingDataSate !== "LOADING" && (
          <div
            className="absolute top-4 right-4 flex p-1 "
            style={{
              zIndex: 100,
              backgroundColor: "#F2F2F5",
              borderRadius: "20px",
            }}
          >
            <img
              src={CrossIcon}
              alt="OverView Icon"
              style={{ cursor: "pointer" }}
              onClick={() => {
                setAccessToggle(false);
              }}
            />
          </div>
        )}
      </div>
    </Modal>
  );
};

export default AccessBrandModal;
